export default __webpack_public_path__ + "static/hero-layer-6-85af961a608a0840a2a1afc30b6751fa.svg";